import React, {FC, useEffect, useRef, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import Select from 'react-select'
import {fetchData, handleTimeChange, toasterrormsg, toastsuccessmsg} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {AddHotelHeader} from './AddHotelHeader'
import moment from 'moment'
import JoditEditor from 'jodit-react'
import {config} from '../../../reusable'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import {Tr} from '../../../_metronic/i18n/Tr'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {formatDuration} from '../advertisement/bannerAdvertisement/AddAdvertisement.constants'

const AddHotelPolicies: FC = () => {
  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '1') {
      navigate('../dashboard/')
    }
  }, [categoryId])
  const divRefEN = useRef(null) as any
  const divRefRU = useRef(null) as any
  const divRefUZ = useRef(null) as any
  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''
  const primaryLanguage = localStorage.getItem('primaryLanguage')
  const [hotelDetails, setHotelDetails] = useState([])
  const [tab, setTab] = useState('1')
  const [apiTabs, setApiTabs] = useState(new Set()) as any
  const [apiData, setApiData] = useState({}) as any // Stores original API data per tab
  var vendorId = ''
  const vendorData = sessionStorage.getItem("vendor")
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
    console.log('No vendor data found')
  }
  const editorRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [checkInTime, setCheckInTime] = useState('')
  const [checkOutTime, setCheckOutTime] = useState('')
  const [cancellationPolicyId, setCancellationPolicyId] = useState('')
  const [cancellationPolicyEN, setCancellationPolicyEN] = useState('')
  const [cancellationPolicyRU, setCancellationPolicyRU] = useState('')
  const [cancellationPolicyUZ, setCancellationPolicyUZ] = useState('')
  const [userGuideEN, setUserGuideEN] = useState('')
  const [userGuideRU, setUserGuideRU] = useState('')
  const [userGuideUZ, setUserGuideUZ] = useState('')
  const [isNonRefundable, setIsNonRefundable] = useState(false)
  const [isFreeCancellation, setIsFreeCancellation] = useState(false)

  // Non-refundable and free cancellation are mutually exclusive; both start unselected
  const handleNonRefundableChange = (e: any) => {
    setIsNonRefundable(e.target.checked)
    if (e.target.checked) setIsFreeCancellation(false)
  }
  const handleFreeCancellationChange = (e: any) => {
    setIsFreeCancellation(e.target.checked)
    if (e.target.checked) setIsNonRefundable(false)
  }
  const getInitialBeforeCheckinDaysList = (tab: any) => {
    if (tab === '1') {
      return [{value: '0', label: t('less than 24 hours')}]
    } else if (tab === '5') {
      return createDaysList(4)
    } else if (tab === '14') {
      return createDaysList(13)
    } else if (tab === '30') {
      return createDaysList(29)
    } else {
      return []
    }
  }

  const createDaysList = (days: any) => {
    const list = []
    for (let i = days; i >= 0; i--) {
      list.push({
        value: i.toString(),
        label: i === 0 ? t('less than 24 hours') : formatDuration(i, 'DAY', lang),
      })
    }
    return list
  }

  useEffect(() => {
    setCancellationDay([{cancellationDay: tab, fee: fee}])
  }, [tab])
  const initialPercentageList = [
    {value: '100', label: `100% ${t('of total price')}`},
    {value: '90', label: `90% ${t('of total price')}`},
    {value: '70', label: `70% ${t('of total price')}`},
    {value: '50', label: `50% ${t('of total price')}`},
  ]

  const [showPolicy, setShowPolicy] = useState(false)

  const togglePolicy = () => {
    setShowPolicy(!showPolicy)
  }

  const [fee, setFee] = useState([{day: '', percentage: ''}])
  const [cancellationDay, setCancellationDay] = useState([{cancellationDay: tab, fee: fee}])

  useEffect(() => {
    // Only update `fee` and `cancellationDay` when switching tabs if the current tab isn't from the API
    if (apiTabs.has(tab) && apiData[tab]) {
      // If the tab has data from the API, use the stored API data
      setFee(apiData[tab].fee)
      setCancellationDay(apiData[tab].cancellationDay)
    } else {
      // If it's not an API tab, set the default values
      const defaultFee =
        tab === '5' || tab === '14' || tab === '30'
          ? [
              {day: '0', percentage: ''},
              {day: '1', percentage: ''},
            ]
          : [{day: '0', percentage: ''}]

      const defaultCancellationDay = {
        cancellationDay: tab,
        fee: defaultFee,
      }

      setFee(defaultFee)
      setCancellationDay([defaultCancellationDay])
    }
  }, [tab, apiTabs])

  const handleAddField = () => {
    setFee([...fee, {day: '', percentage: ''}])
  }

  const handleRemoveField = (index: any) => {
    const newFields = fee.filter((_, i) => i !== index)
    setFee(newFields)
    setCancellationDay([{cancellationDay: tab, fee: newFields}])
  }

  const handleFieldChange = (index: any, field: any, value: any) => {
    const newFields = [...fee] as any
    newFields[index][field] = value
    setFee(newFields)
    setCancellationDay([{cancellationDay: tab, fee: newFields}])
  }

  const filterDaysList = (fields: any) => {
    const selectedDays = fields.map((f: any) => f.day)
    return getInitialBeforeCheckinDaysList(tab).filter((day) => !selectedDays.includes(day.value))
  }

  const filterPercentageList = (fields: any) => {
    const selectedPercentages = fields.map((f: any) => f.percentage)
    return initialPercentageList.filter(
      (percentage) => !selectedPercentages.includes(percentage.value)
    )
  }
  const [policies, setPolicies] = useState([
    {
      en_title: '',
      ru_title: '',
      uz_title: '',
      en_description: '',
      ru_description: '',
      uz_description: '',
    },
  ])

  useEffect(() => {
    if (divRefEN.current) {
      setCancellationPolicyEN(divRefEN.current.innerHTML)
    }
  }, [isNonRefundable, isFreeCancellation, cancellationDay])

  useEffect(() => {
    if (divRefRU.current) {
      setCancellationPolicyRU(divRefRU.current.innerHTML)
    }
  }, [isNonRefundable, isFreeCancellation, cancellationDay])

  useEffect(() => {
    if (divRefUZ.current) {
      setCancellationPolicyUZ(divRefUZ.current.innerHTML)
    }
  }, [isNonRefundable, isFreeCancellation, cancellationDay])

  // set error state
  const [error, setError] = useState([
    {
      cancellationPolicyEN: '',
      cancellationPolicyRU: '',
      cancellationPolicyUZ: '',
      userGuideEN: '',
      userGuideRU: '',
      userGuideUZ: '',
      checkInTime: '',
      checkOutTime: '',
    },
  ])

  const [errors, setErrors] = useState({
    titleEN: '',
    titleRU: '',
    titleUZ: '',
    policyNameEN: '',
    policyNameRU: '',
    policyNameUZ: '',
    descriptionEN: '',
    descriptionRU: '',
    descriptionUZ: '',
  }) as any

  const handleAddPolicy = () => {
    setPolicies([
      ...policies,
      {
        en_title: '',
        ru_title: '',
        uz_title: '',
        en_description: '',
        ru_description: '',
        uz_description: '',
      },
    ])
  }

  const handleRemovePolicy = (index: any) => {
    if (policies.length === 1) return // Prevent removing the last row
    const updatedPolicies = policies.filter((_, i) => i !== index)
    setPolicies(updatedPolicies)
    // Clear errors for removed policy
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  const handlePolicyChange = (index: any, field: any, value: any) => {
    const updatedPolicies = [...policies] as any
    updatedPolicies[index][field] = value
    setPolicies(updatedPolicies)
    // Clear error when user starts typing
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]
    if (checkInTime == '' || checkInTime == null || checkInTime == undefined) {
      errorTmp[0].checkInTime = t('Check In Time Is Required')
      isValid = false
    }
    if (checkOutTime == '' || checkOutTime == null || checkOutTime == undefined) {
      errorTmp[0].checkOutTime = t('Check Out Time Is Required')
      isValid = false
    }
    if (primaryLanguage == 'English') {
      if (
        cancellationPolicyEN.trim() == '' ||
        cancellationPolicyEN.trim() == null ||
        cancellationPolicyEN.trim() == undefined
      ) {
        errorTmp[0].cancellationPolicyEN = t('Cancellation Policy Is Required')
        isValid = false
      }
      if (
        userGuideEN.trim() == '' ||
        userGuideEN.trim() == null ||
        userGuideEN.trim() == undefined
      ) {
        errorTmp[0].userGuideEN = t('User Guide Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        cancellationPolicyRU.trim() == '' ||
        cancellationPolicyRU.trim() == null ||
        cancellationPolicyRU.trim() == undefined
      ) {
        errorTmp[0].cancellationPolicyRU = t('Cancellation Policy Is Required')
        isValid = false
      }
      if (
        userGuideRU.trim() == '' ||
        userGuideRU.trim() == null ||
        userGuideRU.trim() == undefined
      ) {
        errorTmp[0].userGuideRU = t('User Guide Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        cancellationPolicyUZ.trim() == '' ||
        cancellationPolicyUZ.trim() == null ||
        cancellationPolicyUZ.trim() == undefined
      ) {
        errorTmp[0].cancellationPolicyUZ = t('Cancellation Policy Is Required')
        isValid = false
      }
      if (
        userGuideUZ.trim() == '' ||
        userGuideUZ.trim() == null ||
        userGuideUZ.trim() == undefined
      ) {
        errorTmp[0].userGuideUZ = t('User Guide Is Required')
        isValid = false
      }
    }

    if (showPolicy) {
      const newErrors = {} as any
      policies.forEach((policy: any, index: any) => {
        if (primaryLanguage == 'English') {
          if (!policy.en_title) {
            newErrors[index] = {...newErrors[index], titleEN: t('Policy Title Is Required')}
            isValid = false
          }
          if (!policy.en_description) {
            newErrors[index] = {...newErrors[index], descriptionEN: t('Description Is Required')}
            isValid = false
          }
        } else if (primaryLanguage == 'Russian') {
          if (!policy.ru_title) {
            newErrors[index] = {...newErrors[index], titleRU: t('Policy Title Is Required')}
            isValid = false
          }
          if (!policy.ru_description) {
            newErrors[index] = {...newErrors[index], descriptionRU: t('Description Is Required')}
            isValid = false
          }
        } else if (primaryLanguage == 'Uzbek') {
          if (!policy.uz_title) {
            newErrors[index] = {...newErrors[index], titleUZ: t('Policy Title Is Required')}
            isValid = false
          }
          if (!policy.uz_description) {
            newErrors[index] = {...newErrors[index], descriptionUZ: t('Description Is Required')}
            isValid = false
          }
        }
      })
      setErrors(newErrors)
    }
    setError(errorTmp)
    return isValid
  }
  const isValid = fee.every((fees) => {
    return fees.day && fees.percentage
  })
  // add hotel policy api call
  const addHotelPolicies = async () => {
    if (!isNonRefundable && !isFreeCancellation) {
      toasterrormsg(t('Please select a cancellation policy'))
      return
    }
    if (isFreeCancellation && !isValid) {
      toasterrormsg(t('Please Select days or percentage'))
      return
    }
    if (validate()) {
      setDisable(true)
      setLoading(true)
      var param: any = {
        hotelId: editHotelId,
        checkInTime: moment(checkInTime, 'HH:mm:ss').format('HH:mm:ss'),
        checkOutTime: moment(checkOutTime, 'HH:mm:ss').format('HH:mm:ss'),
        en_userGuide: userGuideEN,
        ru_userGuide: userGuideRU,
        uz_userGuide: userGuideUZ,
        en_cancellationPolicy: cancellationPolicyEN,
        ru_cancellationPolicy: cancellationPolicyRU,
        uz_cancellationPolicy: cancellationPolicyUZ,
        isNonRefundable: isNonRefundable ? '1' : '0',
      }
      if (showPolicy) {
        param['customPolicy'] = policies
      }
      if (cancellationPolicyId != '') {
        param['cancellationPolicyId'] = String(cancellationPolicyId)
      }
      if (isFreeCancellation) {
        param['cancellationDay'] = cancellationDay
      }

      var response: any = await fetchData('public/addpolicyV2', param)

      if (response.status == '200') {
        toastsuccessmsg(t('Policies Added Successfully!'))
        const state = {
          hotelId: editHotelId,
        }
        setTimeout(() => {
          navigate('../viewrooms/', {state})
          setDisable(false)
        }, 1500)
      } else {
        toasterrormsg(response.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }
  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
    }
    var response: any = await fetchData('public/hotelDetailsV2', param)
    if (response.status == '200') {
      setHotelDetails(response.data)
      var data = response.data[0]
      setUserGuideEN(data.en_userGuide)
      setUserGuideRU(data.ru_userGuide)
      setUserGuideUZ(data.uz_userGuide)
      setCheckInTime(data.checkInTime)
      setCheckOutTime(data.checkOutTime)
      setCancellationPolicyId(data.cancellationPolicyId)
      setCancellationPolicyEN(data.en_cancellationPolicy)
      setCancellationPolicyRU(data.ru_cancellationPolicy)
      setCancellationPolicyUZ(data.uz_cancellationPolicy)
      const nonRefundable = data.isNonRefundable == 1 || data.isNonRefundable === true
      setIsNonRefundable(nonRefundable)
      setIsFreeCancellation(!nonRefundable && data.cancellationDay.length > 0)
      if (data.cancellationDay.length > 0) {
        const apiTab = data.cancellationDay[0]['cancellationDay']
        setTab(apiTab)
        setFee(data.cancellationDay[0]['fee'])
        setCancellationDay(data.cancellationDay)
        setApiData((prev: any) => ({
          ...prev,
          [apiTab]: {
            fee: data.cancellationDay[0]['fee'],
            cancellationDay: data.cancellationDay,
          },
        }))
        // Mark this tab as API-provided
        setApiTabs(new Set([...apiTabs, apiTab]))
      }
      if (data.customPolicy.length != 0) {
        setShowPolicy(true)
        setPolicies(data.customPolicy)
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
  }, [])

  useEffect(() => {
    document.title = 'Insayr | Add Hotel - Policies';
  }, []);

  return (

    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editHotelId != '' ? t('Edit Policies') : t('Add Policies')}
      </PageTitle>
      <AddHotelHeader hotelId={editHotelId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Policies')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {hotelDetails.length != 0 ? (
                            <>
                              {hotelDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['roomAndSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <React.Fragment key={index}>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </React.Fragment>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-5 form-label'>{t('Check In Time')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Flatpickr
                              data-enable-time
                              value={checkInTime}
                              onChange={(date) => {
                                setCheckInTime(handleTimeChange(date))
                                removeError('checkInTime')
                              }}
                              options={{
                                enableTime: true, // Enable time selection
                                noCalendar: true, // Hide the date picker, only show time
                                dateFormat: 'H:i', // 24-hour format (H:i)
                                time_24hr: true, // Enforces 24-hour format
                                minuteIncrement: 15, // 15-minute increments in dropdown
                                allowInput: false, // Allow typing custom times
                              }}
                              defaultValue={'00:00'}
                              className='form-control mb-2'
                            />
                            {/* <input type="time" name="checkInTime" className="form-control mb-2" value={checkInTime} onChange={(e) => {setCheckInTime(e.target.value);removeError('checkInTime');}}/> */}
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].checkInTime}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-5 form-label'>
                              {t('Check Out Time')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Flatpickr
                              data-enable-time
                              value={checkOutTime}
                              onChange={(date) => {
                                setCheckOutTime(handleTimeChange(date))
                                removeError('checkOutTime')
                              }}
                              options={{
                                enableTime: true, // Enable time selection
                                noCalendar: true, // Hide the date picker, only show time
                                dateFormat: 'H:i', // 24-hour format (H:i)
                                time_24hr: true, // Enforces 24-hour format
                                minuteIncrement: 15, // 15-minute increments in dropdown
                                allowInput: false, // Allow typing custom times
                              }}
                              defaultValue={'00:00'}
                              className='form-control mb-2'
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].checkOutTime}</div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-12 mt-3'>
                            <label className='fs-3 form-label fw-bolder'>
                              {t('Cancellation Policy')}
                            </label>
                          </div>
                          <div className='col-lg-12 my-5'>
                            <label className='d-flex text-start' data-kt-button='true'>
                              {/* <!--begin::Radio--> */}
                              <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='byDay'
                                  value='true'
                                  checked={isNonRefundable}
                                  onChange={(e) => {
                                    handleNonRefundableChange(e)
                                    removeError('isNonRefundable')
                                  }}
                                />
                              </span>
                              {/* <!--end::Radio--> */}
                              {/* <!--begin::Info--> */}
                              <span className='ms-5'>
                                <span className='fs-4 fw-bold text-gray-800 d-block'>
                                  {' '}
                                  {t('Non-refundable')}
                                </span>
                              </span>
                              {/* <!--end::Info--> */}
                            </label>
                            <label className='form-label'>
                              {t(
                                'Guest will pay the full amount if they cancel after reservation.'
                              )}
                            </label>
                          </div>
                          {/* <div className='col-lg-12 my-5'>
                            <label className='d-flex text-start' data-kt-button='true'>
                              `<span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='byDay'
                                  value='true'
                                  checked={isNonRefundable}
                                  onChange={(e) => {
                                    handleNonRefundableChange(e)
                                    removeError('isNonRefundable')
                                  }}
                                />
                              </span> 
                            </label>
                          </div> */}
                          <div className='col-lg-12 my-3'>
                            <label className='d-flex text-start' data-kt-button='true'>
                              <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='freeCancellation'
                                  value='true'
                                  checked={isFreeCancellation}
                                  onChange={(e) => {
                                    handleFreeCancellationChange(e)
                                    removeError('isNonRefundable')
                                  }}
                                />
                              </span>
                              <span className='ms-5'>
                                <span className='fs-4 fw-bold text-gray-800 d-block'>
                                  {t('Free Cancellation rules')}
                                </span>
                              </span>
                            </label>
                          </div>
                          {isFreeCancellation && (
                            <>
                              <div className='col-lg-6 my-3'>
                                <div className='row'>
                                  <div className='col-lg-12 my-5'>
                                    <label className='fs-5 form-label fw-semibold'>
                                      {t(
                                        'How many days before arrival can guests cancel their booking for free?'
                                      )}
                                    </label>
                                  </div>
                                  <div className='col-lg-12'>
                                    <ul className='nav nav-pills nav-fill'>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${
                                            tab == '1' ? 'active' : ''
                                          }`}
                                          onClick={() => setTab('1')}
                                        >
                                          {t('1 Day')}
                                        </button>
                                      </li>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${
                                            tab == '5' ? 'active' : ''
                                          }`}
                                          onClick={() => setTab('5')}
                                        >
                                          {t('5 Days')}
                                        </button>
                                      </li>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${
                                            tab == '14' ? 'active' : ''
                                          }`}
                                          onClick={() => setTab('14')}
                                        >
                                          {t('14 Days')}
                                        </button>
                                      </li>
                                      <li className='nav-item'>
                                        <button
                                          className={`nav-link tab-link ${
                                            tab == '30' ? 'active' : ''
                                          }`}
                                          onClick={() => setTab('30')}
                                        >
                                          {t('30 Days')}
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className='col-lg-12'>
                                    {tab == '1' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(
                                            'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 1 days before check-in.'
                                          )}
                                        </span>
                                      </label>
                                    )}
                                    {tab == '5' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(
                                            'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 5 days before check-in.'
                                          )}
                                        </span>
                                      </label>
                                    )}
                                    {tab == '14' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(
                                            'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 14 days before check-in.'
                                          )}
                                        </span>
                                      </label>
                                    )}
                                    {tab == '30' && (
                                      <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                        <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                        <span>
                                          {t(
                                            'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 30 days before check-in.'
                                          )}
                                        </span>
                                      </label>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-6 my-3'>
                                <div className='row'>
                                  <div className='col-lg-12 my-5'>
                                    <label className='fs-5 form-label fw-semibold'>
                                      {t(
                                        'What are the fees if they cancel within these days before check in:'
                                      )}
                                    </label>
                                  </div>
                                  <div className='col-lg-6'>
                                    <label className='required fs-4 form-label'>
                                      {t('Days before check in')}
                                    </label>
                                  </div>
                                  <div className='col-lg-6'>
                                    <label className='required fs-4 form-label'>{t('Fee')}</label>
                                  </div>
                                  {fee.map((field, index) => (
                                    <div key={index} className='row'>
                                      <div className='col-lg-6 my-3'>
                                        <Select
                                          name='beforeCheckinDays[]'
                                          id='beforeCheckinDaysList'
                                          placeholder={t('Select Days')}
                                          isSearchable={true}
                                          isDisabled={field.day == '0' || field.day == '1'}
                                          options={filterDaysList(fee)}
                                          value={getInitialBeforeCheckinDaysList(tab).find(
                                            (option) => option.value === field.day
                                          )}
                                          onChange={(e: any) =>
                                            handleFieldChange(index, 'day', e.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-6 my-3'>
                                        <Select
                                          name='percentage[]'
                                          id='percentageList'
                                          placeholder={t('Select')}
                                          isSearchable={true}
                                          // options={filterPercentageList(fee)}
                                          options={initialPercentageList}
                                          value={
                                            initialPercentageList.find(
                                              (option) => option.value === field.percentage
                                            ) || null
                                          }
                                          onChange={(e: any) =>
                                            handleFieldChange(index, 'percentage', e.value)
                                          }
                                        />
                                      </div>
                                      {((index > 0 && tab == '1') || (index > 1 && tab != '1')) && (
                                        <div className='col-lg-12 d-flex justify-content-end my-3'>
                                          <button
                                            className='btn btn-danger mb-2'
                                            onClick={() => handleRemoveField(index)}
                                          >
                                            {t('Remove')}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                  <div className='col-lg-12 d-flex justify-content-end my-3'>
                                    <button
                                      className='btn btn-success mb-2'
                                      onClick={handleAddField}
                                    >
                                      {t('Add More')}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        {/* <!--end::Input group--> */}
                        {primaryLanguage == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyEN'
                                  ref={divRefEN}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Free cancellation:
                                          </span>{' '}
                                          You can cancel for free up to{' '}
                                          {cancellationDay[0]['cancellationDay'] == '1'
                                            ? cancellationDay[0]['cancellationDay'] + ' day'
                                            : cancellationDay[0]['cancellationDay'] + ' days'}{' '}
                                          before check-in. No charges will apply.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              If you cancel{' '}
                                              {fee['day'] == '0'
                                                ? 'less than 24 hours'
                                                : fee['day'] + ' days'}{' '}
                                              before check-in, you will be charged{' '}
                                              {fee['percentage']}% of the total booking price.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          If you do not show up for your booking, no refund will be
                                          issued.
                                        </li>
                                        <li>
                                          Once you check in, no refund will be provided for any
                                          unused days or early check-out.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Non-refundable</span>
                                        </li>
                                      </ul>
                                      <p>
                                        You will pay the full amount if you can cancel the
                                        reservation.
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyRU'
                                  ref={divRefRU}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Бесплатная отмена:
                                          </span>{' '}
                                          Вы можете отменить бронирование бесплатно за{' '}
                                          {cancellationDay[0]['cancellationDay']} дней до заезда.
                                          Плата не взимается.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              Если вы отмените бронирование{' '}
                                              {fee['day'] == '0'
                                                ? 'менее чем за 24 часа до'
                                                : 'за ' + fee['day'] + ' дней'}{' '}
                                              до заезда, с вас будет взиматься {fee['percentage']}%
                                              от общей стоимости бронирования.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Если вы не приедете в объект размещения или не
                                          воспользуетесь бронированием, возврат средств не
                                          производится.
                                        </li>
                                        <li>
                                          После регистрации заезда возврат средств за
                                          неиспользованные дни или ранний выезд не производится.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Нет возврата</span>
                                        </li>
                                      </ul>
                                      <p>Вы заплатите полную сумму, если отмените бронирование.</p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyUZ'
                                  ref={divRefUZ}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Bepul bekor qilish:
                                          </span>{' '}
                                          Bron sanasidan {cancellationDay[0]['cancellationDay']} kun
                                          oldin bepul bekor qilishingiz mumkin. Hech qanday to‘lov
                                          olinmaydi.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              Agar bron
                                              {fee['day'] == '0'
                                                ? 'ni 24 soatdan kam vaqt qolganida'
                                                : ' sanasidan ' + fee['day'] + ' kun oldin'}{' '}
                                              bekor qilsangiz, sizdan jami bron narxining{' '}
                                              {fee['percentage']}% ushlab qolinadi.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Agar siz bron sanasida manzilga kelmasangiz va
                                          foydalanmasangiz, to'lov qaytarilmaydi.
                                        </li>
                                        <li>
                                          Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki erta
                                          chiqib ketilganligi uchun to'lovlar qaytarilmaydi.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Qaytarilmaydi</span>
                                        </li>
                                      </ul>
                                      <p>
                                        Agar siz bronni bekor qilsangiz, to'lovingiz to'liq miqdorda
                                        ushlab qolinadi va qaytarib berilmaydi
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-5 form-label'>
                                  {t('User Guide (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideEN}
                                  onBlur={(newContent) => {
                                    setUserGuideEN(newContent)
                                    removeError('userGuideEN')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].userGuideEN}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideRU}
                                  onBlur={(newContent) => {
                                    setUserGuideRU(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>{t('User Guide (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideUZ}
                                  onBlur={(newContent) => {
                                    setUserGuideUZ(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguage == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Cancellation Policy (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyRU'
                                  ref={divRefRU}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Бесплатная отмена:
                                          </span>{' '}
                                          Вы можете отменить бронирование бесплатно за{' '}
                                          {cancellationDay[0]['cancellationDay']} дней до заезда.
                                          Плата не взимается.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              Если вы отмените бронирование{' '}
                                              {fee['day'] == '0'
                                                ? 'менее чем за 24 часа до'
                                                : 'за ' + fee['day'] + ' дней'}{' '}
                                              до заезда, с вас будет взиматься {fee['percentage']}%
                                              от общей стоимости бронирования.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Если вы не приедете в объект размещения или не
                                          воспользуетесь бронированием, возврат средств не
                                          производится.
                                        </li>
                                        <li>
                                          После регистрации заезда возврат средств за
                                          неиспользованные дни или ранний выезд не производится.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Нет возврата</span>
                                        </li>
                                      </ul>
                                      <p>Вы заплатите полную сумму, если отмените бронирование.</p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyEN'
                                  ref={divRefEN}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Free cancellation:
                                          </span>{' '}
                                          You can cancel for free up to{' '}
                                          {cancellationDay[0]['cancellationDay'] == '1'
                                            ? cancellationDay[0]['cancellationDay'] + ' day'
                                            : cancellationDay[0]['cancellationDay'] + ' days'}{' '}
                                          before check-in. No charges will apply.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              If you cancel{' '}
                                              {fee['day'] == '0'
                                                ? 'less than 24 hours'
                                                : fee['day'] + ' days'}{' '}
                                              before check-in, you will be charged{' '}
                                              {fee['percentage']}% of the total booking price.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          If you do not show up for your booking, no refund will be
                                          issued.
                                        </li>
                                        <li>
                                          Once you check in, no refund will be provided for any
                                          unused days or early check-out.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Non-refundable</span>
                                        </li>
                                      </ul>
                                      <p>
                                        You will pay the full amount if you can cancel the
                                        reservation.
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyUZ'
                                  ref={divRefUZ}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Bepul bekor qilish:
                                          </span>{' '}
                                          Bron sanasidan {cancellationDay[0]['cancellationDay']} kun
                                          oldin bepul bekor qilishingiz mumkin. Hech qanday to‘lov
                                          olinmaydi.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              Agar bron
                                              {fee['day'] == '0'
                                                ? 'ni 24 soatdan kam vaqt qolganida'
                                                : ' sanasidan ' + fee['day'] + ' kun oldin'}{' '}
                                              bekor qilsangiz, sizdan jami bron narxining{' '}
                                              {fee['percentage']}% ushlab qolinadi.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Agar siz bron sanasida manzilga kelmasangiz va
                                          foydalanmasangiz, to'lov qaytarilmaydi.
                                        </li>
                                        <li>
                                          Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki erta
                                          chiqib ketilganligi uchun to'lovlar qaytarilmaydi.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Qaytarilmaydi</span>
                                        </li>
                                      </ul>
                                      <p>
                                        Agar siz bronni bekor qilsangiz, to'lovingiz to'liq miqdorda
                                        ushlab qolinadi va qaytarib berilmaydi
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 required form-label'>
                                  {t('User Guide (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideRU}
                                  onBlur={(newContent) => {
                                    setUserGuideRU(newContent)
                                    removeError('userGuideRU')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].userGuideRU}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideEN}
                                  onBlur={(newContent) => {
                                    setUserGuideEN(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>{t('User Guide (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideUZ}
                                  onBlur={(newContent) => {
                                    setUserGuideUZ(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguage == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 required form-label'>
                                  {t('Cancellation Policy (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyUZ'
                                  ref={divRefUZ}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Bepul bekor qilish:
                                          </span>{' '}
                                          Bron sanasidan {cancellationDay[0]['cancellationDay']} kun
                                          oldin bepul bekor qilishingiz mumkin. Hech qanday to‘lov
                                          olinmaydi.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              Agar bron
                                              {fee['day'] == '0'
                                                ? 'ni 24 soatdan kam vaqt qolganida'
                                                : ' sanasidan ' + fee['day'] + ' kun oldin'}{' '}
                                              bekor qilsangiz, sizdan jami bron narxining{' '}
                                              {fee['percentage']}% ushlab qolinadi.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Agar siz bron sanasida manzilga kelmasangiz va
                                          foydalanmasangiz, to'lov qaytarilmaydi.
                                        </li>
                                        <li>
                                          Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki erta
                                          chiqib ketilganligi uchun to'lovlar qaytarilmaydi.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Qaytarilmaydi</span>
                                        </li>
                                      </ul>
                                      <p>
                                        Agar siz bronni bekor qilsangiz, to'lovingiz to'liq miqdorda
                                        ushlab qolinadi va qaytarib berilmaydi
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyRU'
                                  ref={divRefRU}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Бесплатная отмена:
                                          </span>{' '}
                                          Вы можете отменить бронирование бесплатно за{' '}
                                          {cancellationDay[0]['cancellationDay']} дней до заезда.
                                          Плата не взимается.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              Если вы отмените бронирование{' '}
                                              {fee['day'] == '0'
                                                ? 'менее чем за 24 часа до'
                                                : 'за ' + fee['day'] + ' дней'}{' '}
                                              до заезда, с вас будет взиматься {fee['percentage']}%
                                              от общей стоимости бронирования.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          Если вы не приедете в объект размещения или не
                                          воспользуетесь бронированием, возврат средств не
                                          производится.
                                        </li>
                                        <li>
                                          После регистрации заезда возврат средств за
                                          неиспользованные дни или ранний выезд не производится.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Нет возврата</span>
                                        </li>
                                      </ul>
                                      <p>Вы заплатите полную сумму, если отмените бронирование.</p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Cancellation Policy (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <div
                                  id='cancellationPolicyEN'
                                  ref={divRefEN}
                                  className='form-control h-200px'
                                  style={{overflow: 'auto'}}
                                >
                                  {isFreeCancellation && (
                                    <>
                                      <ul>
                                        <li>
                                          <span className='fw-bold text-dark'>
                                            Free cancellation:
                                          </span>{' '}
                                          You can cancel for free up to{' '}
                                          {cancellationDay[0]['cancellationDay'] == '1'
                                            ? cancellationDay[0]['cancellationDay'] + ' day'
                                            : cancellationDay[0]['cancellationDay'] + ' days'}{' '}
                                          before check-in. No charges will apply.
                                        </li>
                                        {cancellationDay[0]['fee'].map((fee: any, index: any) => {
                                          return (
                                            <li key={index}>
                                              If you cancel{' '}
                                              {fee['day'] == '0'
                                                ? 'less than 24 hours'
                                                : fee['day'] + ' days'}{' '}
                                              before check-in, you will be charged{' '}
                                              {fee['percentage']}% of the total booking price.
                                            </li>
                                          )
                                        })}
                                        <li>
                                          If you do not show up for your booking, no refund will be
                                          issued.
                                        </li>
                                        <li>
                                          Once you check in, no refund will be provided for any
                                          unused days or early check-out.
                                        </li>
                                      </ul>
                                    </>
                                  )}
                                  {isNonRefundable == true && (
                                    <>
                                      <ul>
                                        <li className='text-dark' style={{fontWeight: 'bolder'}}>
                                          <span>Non-refundable</span>
                                        </li>
                                      </ul>
                                      <p>
                                        You will pay the full amount if you can cancel the
                                        reservation.
                                      </p>
                                    </>
                                  )}
                                </div>
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 required form-label'>
                                  {t('User Guide (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideUZ}
                                  onBlur={(newContent) => {
                                    setUserGuideUZ(newContent)
                                    removeError('userGuideUZ')
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].userGuideUZ}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideRU}
                                  onBlur={(newContent) => {
                                    setUserGuideRU(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-12 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-5 form-label'>
                                  {t('User Guide (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <JoditEditor
                                  ref={editorRef}
                                  config={config}
                                  value={userGuideEN}
                                  onBlur={(newContent) => {
                                    setUserGuideEN(newContent)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        <div className='row'>
                          <div className='border border-2'></div>
                          <div className='col-lg-12 my-3'>
                            <button className='btn btn-light-success' onClick={togglePolicy}>
                              {t('Add Custom Policy')}
                            </button>
                          </div>
                        </div>

                        {/* <!--end::Input group--> */}
                        {showPolicy &&
                          policies.map((policy, index) => (
                            <div className='row' key={index}>
                              {primaryLanguage == 'English' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className=' fs-4 form-label'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionEN && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionEN}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2 me-1'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Russian' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionRU && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionRU}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2 me-1'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Uzbek' && (
                                <>
                                  <div className='col-lg-12'>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label required'>
                                          {t('Policy Title (Uzbek)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleUZ'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.uz_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'uz_title', e.target.value)
                                          }
                                        />
                                        {errors[index]?.titleUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].titleUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className=' fs-4 form-label'>
                                          {t('Policy Title (Russian)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleRU'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.ru_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'ru_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Policy Title (English)')}
                                        </label>
                                        <input
                                          type='text'
                                          name='titleEN'
                                          placeholder={t('Policy Title')}
                                          className='form-control mb-2'
                                          value={policy.en_title}
                                          onChange={(e) =>
                                            handlePolicyChange(index, 'en_title', e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className='col-lg-2'></div>
                                    </div>
                                    <div className='row'>
                                      <div className='col-lg my-3'>
                                        <label className='required fs-4 form-label'>
                                          {t('Description (Uzbek)')}
                                        </label>
                                        <textarea
                                          name='descriptionUZ'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.uz_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'uz_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                        {errors[index]?.descriptionUZ && (
                                          <div className='text-danger fw-bold'>
                                            {errors[index].descriptionUZ}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (Russian)')}
                                        </label>
                                        <textarea
                                          name='descriptionRU'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.ru_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'ru_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg my-3'>
                                        <label className='fs-4 form-label'>
                                          {t('Description (English)')}
                                        </label>
                                        <textarea
                                          name='descriptionEN'
                                          className='form-control mb-2'
                                          placeholder={t('Description')}
                                          cols={30}
                                          rows={4}
                                          value={policy.en_description}
                                          onChange={(e) =>
                                            handlePolicyChange(
                                              index,
                                              'en_description',
                                              e.target.value
                                            )
                                          }
                                        ></textarea>
                                      </div>
                                      <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                        {index !== 0 && (
                                          <button
                                            className='btn btn-danger mb-2 me-1'
                                            onClick={() => handleRemovePolicy(index)}
                                          >
                                            X
                                          </button>
                                        )}
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddPolicy}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addHotelPolicies}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {AddHotelPolicies}
